import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

import {
  Card as MuiCard,
  CardContent,
  LinearProgress,
  Typography,
} from '@material-ui/core'
import { spacing } from '@material-ui/system'
import { ChevronRight as ChevronRightIcon } from '@material-ui/icons'

import { urlFor } from '../../routes'

const Centered = styled.div`
  text-align: center;
`

const Card = styled(MuiCard)(spacing)

const PathContainer = styled.div`
  display: flex;
`

const LocationWrapper = styled(Card)`
  border: 1px solid ${(props) => props.theme.palette.grey[300]};
  margin-bottom: ${(props) => props.theme.spacing(4)}px;
  cursor: pointer;
  display: flex;

  &:hover {
    background: ${(props) => props.theme.body.background};
  }
`

const LocationLabelWrapper = styled.div`
  margin: 6px;
`

interface HierarchyPathProps {
  location: {
    data?: { objPath?: { guid?: string; name?: string; icon?: React.FC }[] }
    isLoading: boolean
  }
  title: string
}

const HierarchyPath = (props: HierarchyPathProps) => {
  const { location, title } = props
  return (
    <Card mb={6}>
      <CardContent>
        <Centered>
          <Typography variant="h5" component="h2">
            {title}
          </Typography>
        </Centered>
        {location.isLoading ? (
          <LinearProgress />
        ) : (
          <PathContainer>
            {location.data?.objPath?.map((ancestor, index, arr) => {
              const Icon = ancestor?.icon || null
              const url = urlFor(ancestor)
              return (
                <React.Fragment key={index}>
                  <Link to={url as string}>
                    <LocationWrapper key={ancestor.guid}>
                      {Icon && <Icon />}
                      <LocationLabelWrapper>{ancestor.name}</LocationLabelWrapper>
                    </LocationWrapper>
                  </Link>
                  {index + 1 < arr.length && (
                    <Typography>
                      {' '}
                      <ChevronRightIcon />{' '}
                    </Typography>
                  )}
                </React.Fragment>
              )
            })}
          </PathContainer>
        )}
      </CardContent>
    </Card>
  )
}

export default HierarchyPath
